import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=05f14ad4&scoped=true"
import script from "./mall.vue?vue&type=script&lang=js"
export * from "./mall.vue?vue&type=script&lang=js"
import style0 from "./mall.vue?vue&type=style&index=0&id=05f14ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f14ad4",
  null
  
)

export default component.exports